import styled, { css } from 'styled-components';
import { vars } from '../../../theme';
import spacing from '../../../styles/spacing';
import { inputEase, fontSize } from '../../HBTextField/variables';
import { placeholder, textField } from '../../HBTextField/HBTextField.styles';

import InputBase from '../InputBase';

function getMaterialStyles(size: string, disabled: boolean, error: boolean) {
    return css`
        padding: 6px 0;
        border-bottom: 1px;
        border-bottom-style: solid;
        border-bottom-color: ${error
            ? vars.colors.base.danger
            : vars.colors.base.neutral};
        color: ${disabled
            ? vars.colors.text.disabled
            : vars.colors.text.primary};
        ${fontSize[size]};
        ${placeholder(fontSize[size], 'transparent')};

        & ~ label {
            pointer-events: none;
            position: absolute;
            top: 50%;
            left: 0;
            color: ${disabled
                ? vars.colors.text.disabled
                : vars.colors.text.tertiary};
            transform: translate3d(0, -50%, 0);
            transition: all ${inputEase};
            ${fontSize[size]};
        }

        &.not-empty ~ label,
        &:focus ~ label {
            ${fontSize.xs};
            transform: translate3d(0);
            top: -6px;
            color: ${disabled
                ? vars.colors.text.disabled
                : vars.colors.text.secondary};
        }

        &:focus {
            ${placeholder(fontSize[size], vars.colors.text.tertiary)};
        }

        &:hover {
            border-color: ${vars.colors.base.neutralHover};
        }

        &:focus,
        &:focus:hover {
            border-color: ${vars.colors.stroke.secondary};
        }

        &:disabled,
        &:disabled:hover {
            border-color: ${vars.colors.stroke.disabled};
            background-color: ${vars.colors.surface.item};
        }

        /* active state */
        &:focus ~ span:before,
        &:focus ~ span:after {
            width: 50%;
        }
    `;
}

/* Bar */
export const Bar = styled.span<{ error?: boolean }>`
    position: relative;
    display: block;
    width: 100%;

    &:before,
    &:after {
        content: '';
        height: 1px;
        position: absolute;
        width: 0;
        bottom: 0px;
        background: ${props =>
            props.error ? vars.colors.base.danger : vars.colors.text.primary};
        transition: all ${inputEase};
    }
    &:before {
        left: 50%;
    }
    &:after {
        right: 50%;
    }
`;

/* Input extends from InputBase */
export const Input = styled(InputBase)`
    && {
        ${textField};
        transition: all ${inputEase};
        ${props => props.readOnly && 'pointer-events: none'};
        ${props => getMaterialStyles(props.size, props.disabled, props.error)}

        & ~ .helper-text {
            position: absolute;
            bottom: -${spacing[20]};
            left: 0;
            margin: 0;
        }
    }
`;
